/* React */
import React from "react";

/* Ionic */
import { IonItem } from "@ionic/react";

/* Simple Bar */
import SimpleBar from "simplebar-react";

/* Stylesheet */
import styles from "./ItemContainer.module.scss";

/* Interfaces */
import { FilterType } from "src/shared/interfaces/insights-filter/InsightsFilter";

interface ItemContainerProps {
  itemKey?: FilterType;
  items: string[];
  disabled?: boolean;
  handleItem: (itemKey: FilterType, value?: string) => void;
  handleItemContainer: (value: boolean) => void;
}

const ItemContainer: React.FC<ItemContainerProps> = ({
  itemKey,
  items,
  handleItem,
  handleItemContainer,
}) => {
  return (
    <SimpleBar
      className={`${styles.item_container} filter_select_scrollbar`}
    >
      {items.map((item, index) => (
        <IonItem
          key={index}
          className={styles.item}
          lines="none"
          button
          onClick={() => {
            handleItem(itemKey!, item);
            handleItemContainer(false);
          }}
        >
          {item}
        </IonItem>
      ))}
    </SimpleBar>
  );
};

export default ItemContainer;
